import React, {Fragment} from 'react';

const UpdateHasCanceledStep = () => {
  return (
    <Fragment>
      <div>
        You can now close this window.
      </div>
    </Fragment>
  );
};

export default UpdateHasCanceledStep;
